<template>
  <div class="wrap">
    <header style=" display: flex;justify-content: center;">
      <span style="position: absolute;left: 20px;" class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{ lang.czfs }}</h2>
    </header>
    <div class="main">
      <p class="title">{{ lang.bankcardinfo }}</p>
      <p v-if="!bankName" class="item" @click="changeNav('AddBankCard')">
        <span><img src="@img/bankcard.png" alt="">{{ lang.addBank }}</span>
        <span class="iconfont icon-back-right"></span>
      </p>
      <div v-else class="iteminfo">
        <img src="@img/bankcard.png">
        <p>
          <span>{{bankName}}</span>
          <span>{{bankAcc}}</span>
        </p>
      </div>
      <p class="title">{{ lang.Crypto }}</p>
      <p v-if="!ccyName" class="item" @click="changeNav('AddCryptocurrency')">
        <span><img src="@img/bitcoin.png" alt="">{{lang.addCrypto}}</span>
        <span class="iconfont icon-back-right"></span>
      </p>
      <div v-else class="iteminfo">
        <img src="@img/bitcoin.png">
        <p>
          <span>{{bankName}}</span>
          <span>{{bankAcc}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex';
  export default {
    data() {
      return {
        bankName:'',
        bankAcc:'',
        ccyName:'',
        ccyAdd:'',
      }
    },
    mounted() {
      
    },
    created() {
      // this.getData()
    },
    computed: {
      ...mapState(['lang'])
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      changeNav(name){
        this.$router.push(name);
      },
      getData() {
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/user/withdrawPage')
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              let card = res.data.card.split(':');
              let ccy = res.data.ccy.split(':');
              this.bankName = card[0];
              this.bankAcc = card[1];
              this.ccyName = ccy[0];
              this.ccyAdd = ccy[1];
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              sessionStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      },
    }
  }
</script>
<style type="text/css"  scoped>
  .title{
    margin-top:20px;
    padding-left:12px;
    color:#333;
    font-size: 16px;
    font-weight: bold;
  }

  .item{
    margin:12px;
    padding:0 12px;
    height: 60px;
    border-radius: 6px;
    background: #f5f5f5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color:#666;
  }
  .item img{
    width: 30px;
    vertical-align: middle;
    margin-right:5px;
  }


  .iteminfo{
    position:relative;
    margin:12px;
    padding:0 12px;
    height: 60px;
    border-radius: 6px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    color:#666;
    overflow: hidden;
  }
  .iteminfo img{
    width: 30px;
    vertical-align: middle;
    margin-right:5px;
  }

  .iteminfo p{
    display: flex;
    flex-direction: column;
  }
  .iteminfo p span:last-child{
    font-size: 12px;
    color:#999;
  }

</style>